module.exports = __webpack_public_path__ + "img/s00156.054f67af.png";